import { c as _c } from "react/compiler-runtime";
import { Typography } from '@mui/material';
export function SelectPlaceholder(t0) {
  const $ = _c(2);
  const {
    title: t1
  } = t0;
  const title = t1 === undefined ? "Select" : t1;
  let t2;
  if ($[0] !== title) {
    t2 = <Typography variant="body1" color="var(--mui-palette-text-disabled)" className="truncate" alignContent="center" component="span">{title}</Typography>;
    $[0] = title;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
}